export default "__VITE_ASSET__898d0d00__"